var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-area",style:({height:_vm.height + 'px'})},[_c('YHandle',{on:{"heightChange":_vm.heightChange}}),_vm._v(" "),_c('div',{staticClass:"bottom-inner"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d75a96f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/BottomArea.vue
// module id = 283
// module chunks = 0